/**
 * @description Loads intl polyfill and locale data if there is no window.Intl
 * @param {string} locale
 */
export function clientIntlPolyfill() {
    if (!window.Intl.PluralRules) {
        return import(/* webpackChunkName: "intlClientPolyfill" */ '../src/intl/polyfill');
    } else {
        return Promise.resolve();
    }
}
